import Breakpoint from './modules/breakpoint';
import swatchList from './modules/swatch-list';

const handleChangePage = (e) => {
  const page = e.target.getAttribute('data-page');
  const params = new URLSearchParams(window.location.search);
  params.set('page', page);

  const url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
  window.location.assign(`${url}?${params.toString()}#content-results`);
};

const setupPaginationEvents = () => {
  const pageOptions = document.querySelectorAll('.change-page');
  if (pageOptions.length === 0) {
    return;
  }

  pageOptions.forEach((p) => { p.onclick = handleChangePage; });
};

const focusToResultsOnSearch = () => {
  const productResults = document.querySelectorAll('.card-image');
  const contentResults = document.querySelectorAll('.content-link');
  if (productResults.length) {
    const first = productResults[0];
    first.focus();
  } else if (contentResults.length) {
    const first = contentResults[0];
    first.focus();
  }
};

const init = () => {
  const map = {};
  map[Breakpoint.XS.name] = 3;
  map[Breakpoint.SM.name] = 3;
  map[Breakpoint.MD.name] = 4;
  map[Breakpoint.LG.name] = 2;
  map[Breakpoint.XL.name] = 4;
  map[Breakpoint.XXL.name] = 4;
  swatchList('.product-swatch-list', map);

  setupPaginationEvents();
  focusToResultsOnSearch();
};

init();
